<template>
  <div class="qtSplit">
    <div class="split-left" :style="{ width: 'calc(' + leftWidth + '% - 5px)' }">
      <div class="elContent2">
        <div class="main-content2">
          <slot name="left"></slot>
        </div>
      </div>
    </div>
    <div
      v-if="rightCount == 1"
      class="split-right"
      :style="{ width: 'calc(' + rightWidth + '% - 5px)' }"
    >
      <div class="elContent2">
        <div class="main-content2">
          <slot name="right"></slot>
        </div>
      </div>
    </div>
    <div
      v-if="rightCount == 2"
      class="split-right-1"
      :style="{ width: 'calc(' + rightWidth + '% - 5px)' }"
    >
      <div class="elContent2">
        <div class="main-content2">
          <slot name="rightUp"></slot>
        </div>
      </div>
    </div>
    <div
      v-if="rightCount == 2"
      class="split-right-2"
      :style="{ width: 'calc(' + rightWidth + '% - 5px)' }"
    >
      <div class="elContent2">
        <div class="main-content2">
          <slot name="rightDown"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup name="qtSplit">
import { ref, onMounted, nextTick, onActivated,    } from "vue";

const props = defineProps({
  rightCount: {
    type: Number,
    default: 1,
  },
  // 左边宽度(百分比)
  leftWidth: {
    type: Number,
    default: 50,
  },
  // 右边宽度(百分比)
  rightWidth: {
    type: Number,
    default: 50,
  },
});

onMounted(() => {
  nextTick(() => {
    onSetHeight();

    window.addEventListener("resize", () => {
      onSetHeight();
    });
  });
});

onActivated(() => {
  nextTick(() => {
    onSetHeight();
  });
});

const setTableHeight = (splitDom) => {
  let isPager = splitDom.getElementsByClassName("el-pagination").length;
  let pagerHeight = isPager ? 50 : 10;
  let baseSearchDom = splitDom.getElementsByClassName("baseSearch");
  let tabsDom = splitDom.getElementsByClassName("el-tabs");
  let baseSearchHeight = 0;
  if (baseSearchDom.length > 0) {
    baseSearchHeight = baseSearchDom[0].offsetHeight + 20 + 10;
  }

  if (tabsDom.length > 0) {
    baseSearchHeight += 74;
  }

  let tableDom = splitDom.getElementsByClassName("el-table--fit");
  if (tableDom.length > 0)
    tableDom[0].style.height = `calc(100vh - 56px - 30px - 10px - 28px - 10px - 8px - ${pagerHeight}px - ${baseSearchHeight}px)`;
};

const setTableHeight2 = (splitDom) => {
  let isPager = splitDom.getElementsByClassName("el-pagination").length;
  let pagerHeight = isPager ? 50 : 10;
  let tableFitDom = splitDom.getElementsByClassName("el-table--fit");
  if (tableFitDom.length > 0) {
    tableFitDom[0].style.height = `calc((100vh - 56px - 30px - 20px) / 2 - 10px - 10px - 28px - ${pagerHeight}px)`;
  }
};

const onSetHeight = () => {
  let leftDom = document.getElementsByClassName("split-left")[0];
  setTableHeight(leftDom);
  if (props.rightCount == 1) {
    let rightDom = document.getElementsByClassName("split-right")[0];
    setTableHeight(rightDom);
  } else if (props.rightCount == 2) {
    let rightDom1 = document.getElementsByClassName("split-right-1")[0];
    setTableHeight2(rightDom1);

    let rightDom2 = document.getElementsByClassName("split-right-2")[0];
    setTableHeight2(rightDom2);
  }
};

const onReset = (timer) => {
  setTimeout(() => {
    onSetHeight();
  }, timer);
};

defineExpose({ onReset });
</script>
<style scoped>
.split-left {
  float: left;
  background: #fff;
  height: calc(100vh - 56px - 30px - 10px);
}

.split-right {
  float: right;
  background: #fff;
  height: calc(100vh - 56px - 30px - 10px);
}

.split-right-1 {
  float: right;
  background: #fff;
  height: calc((100vh - 56px - 30px - 10px) / 2 - 4px);
  margin-bottom: 4px;
}

.split-right-2 {
  float: right;
  background: #fff;
  height: calc((100vh - 56px - 30px - 10px) / 2 - 4px);
  margin-top: 4px;
}

.main-content2 {
  background: #fff;
  height: 100%;
  box-sizing: border-box;
}
</style>
